import { route } from 'routes-gen'

import { redirect, json } from '@remix-run/node'
import type { LoaderFunctionArgs } from '@remix-run/node'
import { Outlet, useLoaderData } from '@remix-run/react'

import { mockCookie } from '~/utils/mock-server.server'
import { isLocalDev } from '~/utils/dev.server'

import { FullPageLayout, ErrorPage, Marquee } from '~/components'
import { useCaptureRouteError } from '~/utils/sentry-route-error'
import { i18n } from '@lingui/core'

export async function loader({ request }: LoaderFunctionArgs) {
  const { pathname } = new URL(request.url)

  if (pathname == '/erstanmeldung' || pathname == '/erstanmeldung/') {
    return redirect(route('/erstanmeldung/start'))
  }

  const isMock = (await mockCookie().parse(request.headers.get('Cookie'))) != null
  const showDevBanner = isLocalDev(request)
  return json({ isMock, showDevBanner })
}

export function RegisterRoute() {
  const { isMock, showDevBanner } = useLoaderData<typeof loader>()

  return (
    <>
      {showDevBanner && (
        <div className="fixed top-0 left-0 z-30 w-full">
          <Marquee
            text={
              i18n._('This site is still in development...') +
              (isMock ? i18n._(' (mock server enabled)') : '')
            }
          />
        </div>
      )}
      <Outlet />
    </>
  )
}

export default RegisterRoute

export function ErrorBoundary() {
  useCaptureRouteError()
  return (
    <FullPageLayout>
      <div className="h-screen flex flex-col justify-center">
        <ErrorPage />
      </div>
    </FullPageLayout>
  )
}
